import { getDistance } from '../../../shared/libraries/geo'
import { TYPES } from './const'

/**
 * Calculates the correct label for the GMaps.InfoWindow
 * Contains Polyline specific logic: Finds the closest point to the click position and returns it's label
 * For other types returns default content value
 *
 * @param {string} args.type Type of the shape, see "./const"
 * @param {string} args.fallbackContent Content that will be returned for types that don't have any specific logic
 * @param {object} args.clickCoords LanLng of the mouse click
 * @param {array} args.path Optional. Path pf the polyline
 *
 * @returns {string} Content of the GMaps.InfoWindow
 */
export const getInfoWindowContent = ({
  type,
  fallbackContent,
  clickCoords,
  path,
}) => {
  if (type === TYPES.POLYLINE) {
    const { label } = path.reduce(
      (acc, pathPoint) => {
        const distance = getDistance(
          clickCoords.lat,
          clickCoords.lng,
          pathPoint.lat,
          pathPoint.lng,
        )
        if (!acc.closestDistance || distance < acc.closestDistance) {
          return {
            label: pathPoint.label,
            closestDistance: distance,
          }
        }
        return acc
      },
      {
        label: '',
        closestDistance: null,
      },
    )
    return label
  }
  return fallbackContent
}



// WEBPACK FOOTER //
// ./src/Components/GMap/DisplayMap/util.js